import { createRecord } from "../service/custom_records";

export function useHistory() {
    async function createBulkHistory({
        action,
        action_type,
        requester,
        total_count,
        success_count,
        failed_count,
        job_ids,
        status,
        error_summary
    }: {
        action: "create" | "update";
        action_type: "ticket" | "user" | "organization";
        requester: number;
        total_count: number;
        success_count: number;
        failed_count: number;
        job_ids: string;
        status: "completed" | "partial" | "failed" | "pending";
        error_summary?: string;
    }) {
        return createRecord("bulk_ops_relatorio", {
            name: `${action}_${action_type}_${Date.now()}`,
            action,
            action_type,
            requester: requester.toString(),
            date: new Date().toISOString(),
            total_count,
            success_count,
            failed_count,
            job_ids,
            status,
            error_summary
        });
    }

    return { createBulkHistory };
}
